export enum AppointmentConfirmedByType {
  CompanyTeamMember = 'Company::TeamMember',
  Notary = 'Notary'
}
